import { useState } from "react";

function Star({ fill, size = 16, className = "" }) {
    // fill: 0..1 (partial supported)
    const id = "g" + Math.random().toString(36).slice(2, 8);
    return (
        <svg viewBox="0 0 24 24" width={size} height={size} className={className} aria-hidden="true">
            <defs>
                <linearGradient id={id}>
                    <stop offset={`${Math.round(fill * 100)}%`} stopColor="#F59E0B" />
                    <stop offset={`${Math.round(fill * 100)}%`} stopColor="transparent" />
                </linearGradient>
            </defs>
            <path
                d="M12 2l2.9 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l7.1-1.01L12 2z"
                fill={`url(#${id})`}
                stroke="#F59E0B"
                strokeWidth="1"
                strokeOpacity={fill > 0 ? 0.9 : 0.3}
            />
        </svg>
    );
}

export function StarDisplay({ value = 0, count, size = 16, className = "", showCount = true }) {
    return (
        <div className={`inline-flex items-center gap-1.5 ${className}`} data-testid="star-display">
            <div className="flex items-center gap-0.5">
                {[0, 1, 2, 3, 4].map((i) => (
                    <Star key={i} fill={Math.max(0, Math.min(1, value - i))} size={size} />
                ))}
            </div>
            {showCount && (
                <span className="font-mono text-xs text-avx-muted">
                    {value > 0 ? value.toFixed(1) : "—"}{count != null ? ` (${count})` : ""}
                </span>
            )}
        </div>
    );
}

export function StarPicker({ value, onChange, size = 28 }) {
    const [hover, setHover] = useState(0);
    return (
        <div className="flex items-center gap-1" data-testid="star-picker">
            {[1, 2, 3, 4, 5].map((n) => (
                <button
                    type="button"
                    key={n}
                    data-testid={`star-pick-${n}`}
                    onMouseEnter={() => setHover(n)}
                    onMouseLeave={() => setHover(0)}
                    onClick={() => onChange(n)}
                    className="transition-transform hover:scale-110"
                    aria-label={`${n} estrellas`}
                >
                    <Star fill={(hover || value) >= n ? 1 : 0} size={size} />
                </button>
            ))}
        </div>
    );
}
